<style lang="sass">
@import '../../../css/core';

.reservations-table {
  .-header {
    float: left;
  }

  .-body {
    float: left;
    overflow-x: scroll;
    overflow-y: hidden;
  }
}

.staff-breakchange {
  position: relative;
  text-align: center;
}

.staff-timecard {
  position: relative;
  text-align: center;
}
</style>


<template>
  <div>
    <div v-if="isReady" class="reservations-table">
      <break-shift-form
        v-ref:break-shift-form
        :shop="shop">
      </break-shift-form>
        <div class="row">
          <div class="-header" v-bind:style="{width: rowHeaderWidth + 'px'}">
            <row-head :height="timeRulerHeight" :width="rowHeaderWidth"></row-head>
            <collapse-head
               :is-collapsed.sync="isResourceCapacitiesCollapsed"
               :height="unitRowHeight"
               :width="rowHeaderWidth"
               :border-top-width="borderWidth"
               title="空きリソース">
              <row-head :height="unitRowHeight" :width="rowHeaderWidth">シャンプー台</row-head>
              <row-head :height="unitRowHeight" :width="rowHeaderWidth">スタッフ</row-head>
            </collapse-head>
            <row-head v-if="showFreeFrame" :height="reservationsShiftRowHeight()" :width="rowHeaderWidth" :border-top-width="borderWidth">フリー</row-head>
            <row-head
               v-for="staff in staffsInShift"
               :height="reservationsShiftRowHeight(staff)"
               :divide-line-height="3"
               :width="rowHeaderWidth"
               :border-top-width="borderWidth">
              <div>
                <span style="text-align: center;">{{ staff.name }}</span>
              </div>
              <div class="staff-breakchange" @click.prevent="openBreakShiftForm(staff)"><button class="btn btn-info" type="button">休憩時間変更</button></div>
              <div class="staff-timecard" v-show="isToday" v-bind:class="" @click.prevent="trimAttendance(staff)"><button class="btn" :class="{'btn-success': getAttendance(staff)}" type="button">{{ getAttendance(staff) ? '入室中' : '退室中' }}</button></div>
            </row-head>
             <!--
               <staffs-shift-head
               v-if="shifts.length"
               :staffs="staffsInShift"
               :height="staffsShiftRowHeight"
               :width="rowHeaderWidth"
               :border-top-width="borderWidth"
               ></staffs-shift-head>
             -->
             <!-- bottom border -->
             <row-head :width="rowHeaderWidth" :border-top-width="borderWidth"></row-head>
          </div>
          <div
               class="-body clearfix"
               v-bind:style="{width: `calc(100% - ${rowHeaderWidth}px)`}">
            <time-ruler-body
               :business-hour="businessHour"
               :px-per-minute="pxPerMinute"
               :minutes-per-cell="minutesPerCell"
               :height="timeRulerHeight"
               :tick-border-width="borderWidth"
               ></time-ruler-body>
              <collapse-body
               :is-collapsed.sync="isResourceCapacitiesCollapsed"
               :business-hour="businessHour"
               :px-per-minute="pxPerMinute"
               :minutes-per-cell="minutesPerCell"
               :height="unitRowHeight"
               :tick-border-width="borderWidth"
               :border-top-width="borderWidth"
               >
               <template slot="title">
                 <availabilities-body
                         :business-hour="businessHour"
                         :resource-sequence="resourceSequence"
                         :availabilities="availabilities"
                         :px-per-minute="pxPerMinute"
                         :minutes-per-cell="minutesPerCell"
                         :height="unitRowHeight"
                         :tick-border-width="borderWidth"
                         :border-top-width="borderWidth"
                         ></availabilities-body>
               </template>
                <shampoo-sink-capacities-body
                         :business-hour="businessHour"
                         :resource-sequence="resourceSequence"
                         :px-per-minute="pxPerMinute"
                         :minutes-per-cell="minutesPerCell"
                         :height="unitRowHeight"
                         :tick-border-width="borderWidth"
                         ></shampoo-sink-capacities-body>
                  <staff-capacities-body
                         :business-hour="businessHour"
                         :resource-sequence="resourceSequence"
                         :px-per-minute="pxPerMinute"
                         :minutes-per-cell="minutesPerCell"
                         :height="unitRowHeight"
                         :tick-border-width="borderWidth"
                         ></staff-capacities-body>
              </collapse-body>
              <reservations-shift-body
                         v-if="showFreeFrame"
                         :business-hour="businessHour"
                         :px-per-minute="pxPerMinute"
                         :minutes-per-cell="minutesPerCell"
                         :shop="shop"
                         :shops="shops"
                         :reservations="reservationsWithTrack()"
                         :staffs="staffsWithShift"
                         :availabilities="availabilities"
                         :menus="menus"
                         :dyestuffs="dyestuffs"
                         :height="reservationsShiftRowHeight()"
                         :tick-border-width="borderWidth"
                         :border-top-width="borderWidth"
                         :box-height="reservationBoxHeight"
                         :box-margin-top="reservationBoxMarginTop"
                         :box-margin-bottom="reservationBoxMarginBottom"
                         ></reservations-shift-body>
                <reservations-shift-body
                         v-for="staff in staffsInShift"
                         :business-hour="businessHour"
                         :px-per-minute="pxPerMinute"
                         :minutes-per-cell="minutesPerCell"
                         :shop="shop"
                         :shops="shops"
                         :reservations="reservationsWithTrack(staff)"
                         :staffs="staffsWithShift"
                         :menus="menus"
                         :dyestuffs="dyestuffs"
                         :height="reservationsShiftRowHeight(staff)"
                         :tick-border-width="borderWidth"
                         :border-top-width="borderWidth"
                         :box-height="reservationBoxHeight"
                         :box-margin-top="reservationBoxMarginTop"
                         :box-margin-bottom="reservationBoxMarginBottom"
                         :shifts="shifts"
                         :availabilities="availabilities"
                         :no-attend="!getAttendance(staff)"
                         :staff="staff"
                         ></reservations-shift-body>
                  <!--
                    <staffs-shift-body
                    v-if="shifts.length"
                    :business-hour="businessHour"
                    :px-per-minute="pxPerMinute"
                    :minutes-per-cell="minutesPerCell"
                    :staffs="staffsInShift"
                    :shifts="shifts"
                    :height="staffsShiftRowHeight"
                    :tick-border-width="borderWidth"
                    :border-top-width="borderWidth"
                    ></staffs-shift-body>
                  -->
                  <!-- bottom border -->
                  <row-body
                    :business-hour="businessHour"
                    :px-per-minute="pxPerMinute"
                    :minutes-per-cell="minutesPerCell"
                    :border-top-width="borderWidth"
                    ></row-body>
          </div>
        </div>
    </div>
    <div v-else class="center-block">
      Loading...
      <!-- <table>
           <tr>
           <td>予約情報</td>
           <td>{{ loading.reservations ? '読み込み中' : '完了'}}</td>
           </tr>
           <tr>
           <td>利用枠</td>
           <td>{{ loading.availabilities ? '読み込み中' : '完了'}}</td>
           </tr>
           <tr>
           <td>勤怠情報</td>
           <td>{{ loading.attendances ? '読み込み中' : '完了'}}</td>
           </tr>
           <tr>
           <td>営業時間</td>
           <td>{{ loading.businessHour ? '読み込み中' : '完了'}}</td>
           </tr>
           <tr>
           <td>シフト</td>
           <td>{{ loading.shifts ? '読み込み中' : '完了'}}</td>
           </tr>
           <tr>
           <td>スタッフ</td>
           <td>{{ loading.staffs ? '読み込み中' : '完了'}}</td>
           </tr>
           <tr>
           <td>店舗情報</td>
           <td>{{ loading.shops ? '読み込み中' : '完了'}}</td>
           </tr>
           <tr>
           <td>メニュー情報</td>
           <td>{{ loading.menus ? '読み込み中' : '完了'}}</td>
           </tr>
           <tr>
           <td>染料</td>
           <td>{{ loading.dyestuffs ? '読み込み中' : '完了'}}</td>
           </tr>
           <tr>
           <td>ホットペッパー枠</td>
           <td>{{ loading.capacities ? '読み込み中' : '完了'}}</td>
           </tr>
           </table> -->
    </div>
  </div>
</template>


<script lang="babel">
import $ from 'jquery'
import moment from 'moment'
import ReservationStatus from 'ReservationStatus'
import ReservedBy from 'ReservedBy'
import { setWebSocketConnected } from 'actions'

export default {
  name: 'reservations-table',
  props: {
    shop: {
      type: Object,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    pxPerMinute: {
      type: Number,
      default: 3,
    },
    minutesPerCell: {
      type: Number,
      default: 10,
    },
    timeRulerHeight: {
      type: Number,
      default: 30,
    },
    unitRowHeight: {
      default: 30,
    },
    rowHeaderWidth: {
      type: Number,
      default: 120,
    },
    reservationBoxHeight: {
      type: Number,
      default: 120,
    },
    reservationBoxMarginTop: {
      type: Number,
      default: 10,
    },
    reservationBoxMarginBottom: {
      type: Number,
      default: 10,
    },
    isResourceCapacitiesCollapsed: {
      type: Boolean,
      default: true,
    },
    reservationsShiftPaddingBottom: {
      type: Number,
      default: 0,
    },
    borderWidth: {
      type: Number,
      default: 2,
    },
    refreshPeriodInMilliseconds: {
      type: Number,
      default: 10000,
    },
    websocketRetryInterval: {
      type: Number,
      default: 1000,
    },
    displayStatuses: {
      type: Array,
      default: [],
    },
  },
  events: {
    'reservation-created': function (reservation) {
      this.reservations.push(reservation)
      this.fetchAvailabilities()
    },
    'reservation-updated': function (reservation) {
      Object.assign(this.reservations.find(r => r.pk == reservation.pk), reservation)
      this.fetchAvailabilities()
    },
    'tick-over': function (tick) {
      this.$broadcast('tick-set', tick)
    },
    'tick-out': function (tick) {
      this.$broadcast('tick-clear')
    },
  },
  data() {
    return {
      reservations: null,
      businessHour: null,
      shifts: null,
      staffs: null,
      shops: null,
      menus: null,
      dyestuffs: null,
      timerId: null,
      availabilities: [],
      attendances: [],
      webSocket: null,
      loading: {
        reservations: false,
        availabilities: false,
        attendances: false,
        businessHour: false,
        shifts: false,
        staffs: false,
        shops: false,
        menus: false,
        dyestuffs: false,
        capacities: false,
      },
    }
  },
  computed: {
    showFreeFrame() {
      let shifts = this.shifts
      if (!shifts || shifts.length === 0) return true
      let rvs = this.reservationsWithTrack()
      if (!rvs || rvs.length === 0) return false
      return true
    },
    isReady() {
      return this.businessHour && this.reservations && this.shifts && this.staffs && this.menus && this.dyestuffs && this.shops
    },
    isToday () {
      return moment().isSame(this.date, 'day')
    },
    resourceSequence() {
      let sequence = []
      let range = moment.range(`${this.businessHour.openAt}/${this.businessHour.closeAt}`)
      let duration = moment.duration(this.minutesPerCell, 'minutes')

      // 時間枠(tick)ごとにリソースを計算
      range.by(duration, tick => {
        let shifts = this.shiftsWithRange.filter(s => s.range.contains(tick, true))
        let dyeingReservations = this.availableReservations.filter(r => r.dyeingRange.contains(tick, true))
        let shampooReservations = this.availableReservations.filter(r => r.shampooRange.contains(tick, true))

        let shampooSinkRemains = this.shop.shampooSinkNum - shampooReservations.length
        let effectiveShifts = shifts.filter(s => !s.isProbation).filter(s => !((s.breakRange1 && s.breakRange1.contains(tick, true)) ||
                                                                               (s.breakRange2 && s.breakRange2.contains(tick, true)) ||
                                                                               (s.blockRange1 && s.blockRange1.contains(tick, true)) ||
                                                                               (s.blockRange2 && s.blockRange2.contains(tick, true))))
        let staffRemains = effectiveShifts.length - (dyeingReservations.length + shampooReservations.length)

        sequence.push({
          tick: tick,
          shifts: shifts,
          dyeingReservations: dyeingReservations,
          shampooReservations: shampooReservations,
          shampooSinkRemains: shampooSinkRemains,
          staffRemains: staffRemains,
        })
      }, true)

      return sequence
    },
    availableReservations() {
      return this.reservationsWithRange.filter(r =>
        !(r.isRemoved || r.status == ReservationStatus.CANCELLED || r.status == ReservationStatus.NO_SHOW)
      )
    },
    filteredReservations() {
      return this.reservationsWithRange.filter(r => {
        if (r.isRemoved) {
          return this.displayStatuses.includes(-1)
        }
        if (r.status == ReservationStatus.CANCELLED || r.status == ReservationStatus.NO_SHOW) {
          return this.displayStatuses.includes(r.status)
        }
        return true
      })
    },
    reservationsWithRange() {
      return this.reservations.map(r => {
        let range = moment.range(`${r.startAt}/${r.endAt}`)
        let dyeingRange = moment.range(
          range.start,
          range.start.clone().add(r._embedded.menu.timeboxes.dyeing, 'minutes')
        )
        let waitingRange = moment.range(
          dyeingRange.end,
          dyeingRange.end.clone().add(r._embedded.menu.timeboxes.waiting, 'minutes')
        )
        let shampooRange = moment.range(waitingRange.end, range.end)

        return Object.assign({}, r, {
          range: range,
          dyeingRange: dyeingRange,
          waitingRange: waitingRange,
          shampooRange: shampooRange,
        })
      })
    },
    shiftsWithRange() {
      return this.shifts.map(s => {
        return Object.assign({}, s, {
          range: moment.range(`${s.startAt}/${s.endAt}`),
          breakRange1: (s.breakStartAt_1 && s.breakEndAt_1) ? moment.range(`${s.breakStartAt_1}/${s.breakEndAt_1}`) : null,
          breakRange2: (s.breakStartAt_2 && s.breakEndAt_2) ? moment.range(`${s.breakStartAt_2}/${s.breakEndAt_2}`) : null,
          blockRange1: (s.blockStartAt_1 && s.blockEndAt_1) ? moment.range(`${s.blockStartAt_1}/${s.blockEndAt_1}`) : null,
          blockRange2: (s.blockStartAt_2 && s.blockEndAt_2) ? moment.range(`${s.blockStartAt_2}/${s.blockEndAt_2}`) : null,
        })
      })
    },
    hotpepperMailCapacitiesWithRange() {
      return this.hotpepperMailCapacities.map(c => {
        return Object.assign({}, c, {
          range: moment.range(c.startAt, c.endAt)
        })
      })
    },
    staffsInShift() {
      let staffs = {}
      this.shifts.forEach(shift => staffs[shift.staff] = shift._embedded.staff)
      return Object.keys(staffs).map(key => staffs[key])
    },
    staffsWithShift () {
      // スタッフ一覧だと一時停止中のスタッフなどが取れないので，シフトに入っているスタッフとマージさせる
      let ret = []
      this.shifts.forEach(shift => ret.push(shift._embedded.staff))

      this.staffs.forEach(staff => {
        if (!ret.find(x => x.pk === staff.pk)) {
          ret.push(staff)
        }
      })
      return ret
    },
    staffsShiftRowHeight() {
      return this.staffsInShift.length * this.unitRowHeight
    },
  },
  methods: {
    fetchReservations(retry = null) {
      this.loading.reservations = true
      this.apiGet(
        '/api/1.0/reservations/',
        {date: this.date, shop: this.shop.pk},
        {date: this.date, shop: this.shop.pk, ordering: 'date,start_hour,start_minute'}
      ).then(response => {
        this.reservations = response.body.results
        this.loading.reservations = false
      }).catch(() => {
        console.log('error !!!!!!')
        console.log(retry)
        if (!retry) {
          retry = 1
        } else {
          retry = retry + 1
        }
        if (retry < 5) {
          console.log('do retry')
          this.fetchReservations(retry)
        }
      })
    },
    fetchAvailabilities (retry = null) {
      this.loading.availabilities = true
      this.apiGet(
        '/api/1.0/reservations/availabilities/',
        {date: this.date, shop: this.shop.pk},
        {shopAs: this.shop.pk}
      ).then((res) => {
        this.availabilities = res.body.results
        this.loading.availabilities = false
      }).catch(() => {
        if (!retry) {
          retry = 1
        } else {
          retry = retry + 1
        }
        if (retry < 5) {
          this.fetchAvailabilities(retry)
        }
      })
    },
    fetchAttendances (retry = null) {
      this.loading.attendances = true
      this.apiGet(
        '/api/1.0/shifts/attendances/',
        {date: this.date, shop: this.shop.pk, is_open: true},
        {shopAs: this.shop.pk}
      ).then(response => {
        this.attendances = response.body.results
        this.loading.attendances = false
      }).catch(() => {
        if (!retry) {
          retry = 1
        } else {
          retry = retry + 1
        }
        if (retry < 5) {
          this.fetchAttendances(retry)
        }
      })
    },
    fetchBusinessHour (retry = null) {
      this.loading.businessHour = true
      this.apiGet(
        '/api/1.0/business-hours/',
        {date: this.date, shop: this.shop.pk},
        {shopAs: this.shop.pk}
      ).then(response => {
        this.businessHour = response.body.results[0]
        this.loading.businessHour = false
      }).catch(() => {
        if (!retry) {
          retry = 1
        } else {
          retry = retry + 1
        }
        if (retry < 5) {
          this.fetchBusinessHour(retry)
        }
      })
    },
    fetchShifts (retry = null) {
      this.loading.shifts = true
      this.apiGet(
        '/api/1.0/shifts/',
        {date: this.date, shop: this.shop.pk},
        {shopAs: this.shop.pk}
      ).then(response => {
        this.shifts = response.body.results.filter(x => !x.isVacation && !x.isPaidVacation)
        this.loading.shifts = false
      }).catch(() => {
        if (!retry) {
          retry = 1
        } else {
          retry = retry + 1
        }
        if (retry < 5) {
          this.fetchShifts(retry)
        }
      })
    },
    fetchStaffs (retry = null) {
      this.loading.staffs = true
      this.apiGet(
        '/api/1.0/staffs/',
        {page_size: -1, work_shop: this.shop.pk, 'working_at': this.shop.pk},
        {shopAs: this.shop.pk}
      ).then(response => {
        this.staffs = response.body.results
        this.loading.staffs = false
      }).catch(() => {
        if (!retry) {
          retry = 1
        } else {
          retry = retry + 1
        }
        if (retry < 5) {
          this.fetchStaffs(retry)
        }
      })
    },
    fetchShops (retry = null) {
      this.loading.shops = true
      this.apiGet(
        '/api/1.0/shops/',
        {page_size: -1},
        {}
      ).then(response => {
        this.shops = response.body.results
        this.loading.shops = false
      }).catch(() => {
        if (!retry) {
          retry = 1
        } else {
          retry = retry + 1
        }
        if (retry < 5) {
          this.fetchShops(retry)
        }
      })
    },
    fetchMenus (retry = null) {
      this.loading.menus = true
      this.apiGet(
        '/api/1.0/menus/',
        {shop: this.shop.pk},
        {shopAs: this.shop.pk}
      ).then(response => {
        this.menus = response.body.results
        this.loading.menus = false
      }).catch(() => {
        if (!retry) {
          retry = 1
        } else {
          retry = retry + 1
        }
        if (retry < 5) {
          this.fetchMenus(retry)
        }
      })
    },
    fetchDyestuffs (retry = null) {
      this.loading.dyestuffs = true
      this.apiGet(
        '/api/1.0/dyestuffs/',
        {page_size: -1},
        {shopAs: this.shop.pk}
      ).then(response => {
        this.dyestuffs = response.body.results
        this.loading.dyestuffs = false
      }).catch(() => {
        if (!retry) {
          retry = 1
        } else {
          retry = retry + 1
        }
        if (retry < 5) {
          this.fetchDyestuffs(retry)
        }
      })
    },
    fetch() {
      this.fetchReservations()
      this.fetchAvailabilities()
      this.fetchAttendances()

      this.fetchBusinessHour()
      this.fetchShifts()
      this.fetchStaffs()
      this.fetchShops()
      this.fetchMenus()
      this.fetchDyestuffs()

    },
    refresh() {
      this.fetchReservations()
      this.fetchAvailabilities()
      this.$dispatch('reservationRefresh')
    },
    reservationsWithTrack(staff) {
      let reservationsWithTrack = []
      let reservations = this.filteredReservations
      if (staff) {
        reservations = reservations.filter(r => r.respondingStaff === staff.pk || r.respondingShampooStaff === staff.pk)
      } else {
        if (this.shifts) {
          let staffs = this.staffsInShift
          reservations = reservations.filter(r =>
            r.respondingStaff === null ||
                                                !(staffs.some(staff => (staff.pk === r.respondingStaff))) ||
                                                (r.respondingStaff === null && r.respondingShampooStaff) ||
                                                (r.respondingShampooStaff && !(staffs.some(staff => (staff.pk === r.respondingShampooStaff)))))
        }
      }

      reservations.forEach(r => {
        for (let track = 0; true; track++) {
          const isOverlapped = reservationsWithTrack.find(_r => {
            return _r.track == track && _r.range.overlaps(r.range)
          })
          if (!isOverlapped) {
            reservationsWithTrack.push(Object.assign({}, r, {track: track}))
            break
          }
        }
      })

      return reservationsWithTrack
    },
    reservationsShiftTrackCount (staff) {
      return 1 + this.reservationsWithTrack(staff).map(r => r.track).reduce((t1, t2) => Math.max(t1, t2), 0)
    },
    reservationsShiftRowHeight (staff) {
      return this.reservationsShiftTrackCount(staff)
      * (this.reservationBoxHeight + this.reservationBoxMarginTop + this.reservationBoxMarginBottom)
           + this.reservationsShiftPaddingBottom
    },
    openBreakShiftForm (staff) {
      let shifts = this.shifts.filter(shift => shift.staff === staff.pk)
      if (shifts.length !== 1) {
        return
      }
      this.$refs.breakShiftForm.create(shifts[0])
    },
    trimAttendance (staff) {
      if (confirm('変更しますか？') === false) {
        return
      }
      let data = {
        shop: this.shop.pk,
        staff: staff.pk,
      }
      let attendance = this.getAttendance(staff)
      if (attendance) {
        this.apiPut(
          `/api/1.0/shifts/attendances/${attendance.pk}/`,
          data,
          {shopAs: this.shop.pk}
        ).then(res => {
          this.fetchAttendances()
        })
      } else {
        this.apiPost(
          '/api/1.0/shifts/attendances/',
          data,
          {shopAs: this.shop.pk}
        ).then(res => {
          this.fetchAttendances()
        })
      }
    },
    getAttendance (staff) {
      return this.attendances.find( x => x.staff === staff.pk)
    },
    webSocketConnect () {
      if (this.webSocket) {
        return
      }
      let protocol = (('https:' === document.location.protocol) ? 'wss://' : 'ws://')
      let url = protocol + location.host + '/ws?shop_as=' + this.shop.pk
      let webSocket = new WebSocket(url)
      let self = this
      webSocket.onopen = function (event) {
        console.log('接続')
        self.setWebSocketConnected(true)
      }
      webSocket.onerror = function (event) {
        console.log('error')
        console.log(event)
      }
      webSocket.onmessage = function (event) {
        if (event.data === 'pong') {
          console.log('pong')
          return
        }
        console.log('receive message')
        console.log(event)
        let data
        try {
          data = JSON.parse(event.data)
        } catch(e) {
          self.refresh()
          return
        }
        if (!moment(data.date).isSame(self.date)) {
          console.log('other date update')
          return
        }
        const targetIndex = self.reservations.findIndex(x => x.pk === data.pk)
        console.log(targetIndex)
        if (targetIndex >= 0) {
          const oldData = self.reservations[targetIndex]
          if (data.startAt !== oldData.startAt || data.isRemoved !== oldData.isRemoved || ((data.status === 5 && oldData.status !== 5) || (data.status !== 5 && oldData.status === 5))) {
            // 時間変更，削除，キャンセル，キャンセル解除がある場合は枠を取り直す
            self.fetchAvailabilities()
          }
          console.log('find!')
          self.reservations.splice(targetIndex, 1, data)
        } else {
          console.log('not found')
          self.refresh()
        }
      }
      webSocket.onclose = function (event) {
        console.log('closed')
        self.setWebSocketConnected(false)
        self.webSocket = null
        setTimeout(self.webSocketConnect, self.websocketRetryInterval)
      }
      this.webSocket = webSocket
    },
  },
  ready() {
    this.fetch()
    this.webSocketConnect()
    // this.timerId = setInterval(this.refresh, this.refreshPeriodInMilliseconds)
    this.timerId = setInterval(() => {
      if (this.webSocket) {
        this.webSocket.send('ping')
      }
    }, 10000)
    this._refrechIntervalId = setInterval(() => {
      this.refresh()
    }, 60000 * 10)
  },
  beforeDestroy() {
    if (this.timerId) {
      clearInterval(this.timerId)
    }
    if (this._refrechIntervalId) clearInterval(this._refrechIntervalId)
    if (this.webSocket) {
      this.webSocket.onclose = function () {}
      this.webSocket.close()
      this.webSocket = null
      this.setWebSocketConnected(false)
    }
  },
  watch: {
    shop() {
      this.fetch()
    },
    reservations(value) {
      this.$emit('update-reservations', value)
    },
  },
  vuex: {
    actions: {
      setWebSocketConnected: setWebSocketConnected,
    },
  },
  mixins: [
    require('mixin/api-client.vue'),
  ],
  components: {
    rowHead: require('./row/head.vue'),
    rowBody: require('./row/body.vue'),
    timeRulerBody: require('./row/time-ruler/body.vue'),
    collapseHead: require('./row/collapse/head.vue'),
    collapseBody: require('./row/collapse/body.vue'),
    shampooSinkCapacitiesBody: require('./row/shampoo-sink-capacities/body.vue'),
    staffCapacitiesBody: require('./row/staff-capacities/body.vue'),
    availabilitiesBody: require('./row/availabilities/body.vue'),
    reservationsShiftBody: require('./row/reservations-shift/body.vue'),
    staffsShiftHead: require('./row/staffs-shift/head.vue'),
    staffsShiftBody: require('./row/staffs-shift/body.vue'),
    breakShiftForm: require('./modal-form/break-shift.vue'),
  },
}
</script>



// WEBPACK FOOTER //
// index.vue?230ff148